import { takeEvery, call, put, select } from 'redux-saga/effects'

import { isEmpty, isInArray } from 'app/utils/array'
import { isFlorida } from 'app/services/core/entitlement.service'

import {
  KNOWLEDGE_BUILDER_ACTIONS,
  KNOWLEDGE_BUILDERS_ACTIONS,
  knowledgeBuilderActionCreators,
  knowledgeBuildersActionCreators,
} from 'app/store/actions/media/knowledge.actions'
import {
  getKnowledgeBuilders,
  getKnowledgeBuilder,
  getFloridaKnowledgeBuilders,
} from 'app/services/api/data.service'
import { ReduxSagaAction } from 'app/types/store.types'

function* getKnowledgeBuildersSaga(): Generator<unknown, void, any> {
  try {
    let data = yield select((state) => state.theater.knowledgeBuildersList.data)
    const { permissions } = yield select((state) => state.userData.kcInfo)

    if (isEmpty(data)) {
      data = yield call(
        isFlorida(permissions)
          ? getFloridaKnowledgeBuilders
          : getKnowledgeBuilders
      )
    }

    yield put(
      knowledgeBuildersActionCreators.success({
        data,
      })
    )
  } catch (error) {
    yield put(
      knowledgeBuildersActionCreators.failure({
        error,
      })
    )
  }
}

function* getKnowledgeBuilderSaga({
  payload: id,
}: ReduxSagaAction<string>): Generator<unknown, void, any> {
  try {
    let data = yield select((state) => state.theater.knowledgeBuilder.data)

    if (!isInArray(data, 'id', id)) {
      const builder = yield call(getKnowledgeBuilder, id)
      builder.id = id
      data = [...data, builder]
    }

    yield put(
      knowledgeBuilderActionCreators.success({
        data,
      })
    )
  } catch (error) {
    yield put(
      knowledgeBuilderActionCreators.failure({
        error,
      })
    )
  }
}

export function* watchKnowledgeBuildersActions() {
  yield takeEvery(KNOWLEDGE_BUILDERS_ACTIONS.REQUEST, getKnowledgeBuildersSaga)
}

export function* watchKnowledgeBuilderActions() {
  yield takeEvery(KNOWLEDGE_BUILDER_ACTIONS.REQUEST, getKnowledgeBuilderSaga)
}
